import { render, staticRenderFns } from "./preview-pythonfile.vue?vue&type=template&id=26b92dcc&scoped=true"
import script from "./preview-pythonfile.vue?vue&type=script&lang=js"
export * from "./preview-pythonfile.vue?vue&type=script&lang=js"
import style0 from "./preview-pythonfile.vue?vue&type=style&index=0&id=26b92dcc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b92dcc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26b92dcc')) {
      api.createRecord('26b92dcc', component.options)
    } else {
      api.reload('26b92dcc', component.options)
    }
    module.hot.accept("./preview-pythonfile.vue?vue&type=template&id=26b92dcc&scoped=true", function () {
      api.rerender('26b92dcc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/senate/preview-pythonfile.vue"
export default component.exports